import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]

  static values = {
    timeout: Number,
  }

  toggle = () => {
    this.toggleTargets.forEach((target) => {
      target.classList.toggle("hidden")
    })
  }

  showLoading = () => {
    this.toggle()
    setTimeout(this.toggle, this.timeoutValue)
  }
}
